<template>
  <div style="width: 100%; height: 100%">
    <div id="layerMain">
      <div class="mask"></div>
      <div class="layerContent">
        <!-- <div>{{ curData }}</div>  -->
        <div class="left layer-left">
          <div class="layer-left-top">
            <span class="layer-top-cont">{{ countryName }}</span>
<!--            <img src="./img/cn.png" alt="" />-->
            <img :src="formattedPng" alt="">
          </div>
          <div class="layer-left-bot">
<!--            <span class="layer-bot-num">{{ curData && curData.score }}</span>-->
            <span class="layer-bot-num">{{ formattedScore }}</span>
            <span class="layer-bot-text">分</span>
          </div>
        </div>
        <div class="right layer-right">
          <div class="layer-right-li">
            <p>探测日期</p>
<!--            <p>{{ curData && curData.date }}</p>-->
            <p>{{ formattedDate }}</p>
          </div>
          <div class="layer-right-li">
            <p>资产数量</p>
            <p>{{ curNum && curNum.asset_num }}</p>
          </div>
          <div class="layer-right-li">
            <p>受威胁的资产数量</p>
            <p>{{ curNum && curNum.asset_prac }}</p>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="shape">
<!--        <img src="./img/tc_img.png" alt="" />-->
      </div>
<!--      <div class="shape"></div>-->
<!--      <img class="plane" src="./img/plane.jpg" alt="" />-->
    </div>
    <div ref="mapId" style="width: 100%; height: 100%"></div>
  </div>
</template>
<script>
import { EventBus } from "@/utils/eventBus";
import * as THREE from "three"; //导入整个 three.js核心库
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js"; // 轨道控制器 可以使得相机围绕目标进行轨道运动。
import * as TWEEN from "tween";
// import map_img from "../../assets/images/map.jpg";
import map_img from "./img/3dMap.jpg";
import map_wl from "./img/wl.png";
let camera, scene, controls, mesh;

let group = new THREE.Group();

let radius = 50; // 半径

let fov = 100; // 视野角度
// ------------------------

const posArr = [
  {
    x: 0.5738958419746141,
    y: 0.44114968930852216,
    z: 4.9473255920938985
  },
  {
    x: -0.9326350073394328,
    y: 2.8399222968004114,
    z: -4.00812091773949
  }
];
var groupDots = new THREE.Group(); //接收信号的点
var groupLines = new THREE.Group(); //信号轨迹（贝塞尔曲线）

/**
 * 通过两点绘制贝塞尔曲线
 * v0：起点,
 * v3：终点
 */
// 添加线条
function addLines(v0, v3) {
  console.log(v0, v3, 6666);
  //夹角
  var angle = (v0.angleTo(v3) * 1.8) / Math.PI / 0.1; //0~Math.PI
  var aLen = angle * 0.4,
    hLen = angle * angle * 12;
  var p0 = new THREE.Vector3(0, 0, 0); //用于求两点形成的向量的法向量

  // 开始，结束点
  // var v0 = groupDots.children[0].position;
  // var v3 = groupDots.children[1].position;

  //法线向量：THREE.Ray(v1,v2) 向量v1v2缩成方向的法向量
  var rayLine = new THREE.Ray(p0, getVCenter(v0.clone(), v3.clone())); //圆点与向量v0,v3的终点形成的垂直于向量v0v3的向量
  // delete rayLine.direction.isVector3;
  // delete rayLine.origin.isVector3;

  // console.log(rayLine.direction, rayLine.origin);
  debugger;
  //顶点坐标
  var vtop = rayLine.at(hLen / rayLine.at(1).distanceTo(p0));

  //控制点坐标
  var v1 = getLenVcetor(v0.clone(), vtop, aLen);
  var v2 = getLenVcetor(v3.clone(), vtop, aLen);
  //绘制贝塞尔曲线
  var curve = new THREE.CubicBezierCurve3(v0, v1, v2, v3);
  var geometry = new THREE.Geometry();

  geometry.vertices = curve.getPoints(50);
  var material = new THREE.LineBasicMaterial({
    vertexColors: true,
    transparent: true,
    side: THREE.DoubleSide
    // depthWrite:false
  });

  geometry.colors = curve
    .getPoints(50)
    .map((elem, index) =>
      index > 25 ? new THREE.Color(0xbd5cff) : new THREE.Color(0xff00ff)
    );
  var lineMesh = new THREE.Line(geometry, material);

  return {
    curve: curve,
    lineMesh: lineMesh
  };
}

// 计算v1,v2 的中点
function getVCenter(v1, v2) {
  let v = v1.add(v2);

  return v.divideScalar(2);
}

// 计算V1，V2向量固定长度的点
function getLenVcetor(v1, v2, len) {
  let v1v2Len = v1.distanceTo(v2);

  return v1.lerp(v2, len / v1v2Len);
}

export default {
  name: "index",
  props: {
    curData: {
      type: Object,
      default: () => ({})
    },
    curNum: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    formattedScore() {
      return this.curData && this.curData.score
        ? this.curData.score.toFixed(2)
        : "";
    },
    formattedPng() {
      return this.curData && this.curData.id ? require(`../../../assets/Flags/${this.curData.id}.png`) : "";
    },
    formattedDate() {
      if (this.curData && this.curData.date) {
        const date = new Date(this.curData.date);
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        const hours = ("0" + date.getHours()).slice(-2);
        const minutes = ("0" + date.getMinutes()).slice(-2);
        const seconds = ("0" + date.getSeconds()).slice(-2);

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
      return "";
    }
  },
  data() {
    return {
      // curData:{},
      mapDom: null,
      renderer: null,
      animationType: true, // 地球入场动画
      rotationY: true, // 地球自动旋转
      meshAnimateType: false, // 标记点动画
      lonlat: { x: 0, y: 0, z: 200 },
      countryName: null // 数据
    };
  },
  created() {
    EventBus.$on("callSomeMethod", this.clearStyle);
  },
  beforeDestroy() {
    // 停止动画循环
    cancelAnimationFrame(this.animationFrameId);

    // 清理渲染器和场景
    if (this.renderer) {
      this.renderer.dispose();
    }

    scene.traverse((object) => {
      if (object.isMesh) {
        object.geometry.dispose();
        if (Array.isArray(object.material)) {
          object.material.forEach(material => material.dispose());
        } else {
          object.material.dispose();
        }
      }
    });

    group.clear();
    this.renderer.domElement.removeEventListener("click", this.infoMouse);
    EventBus.$off("callSomeMethod", this.clearStyle);
  },

  mounted() {
    this.info();
  },
  methods: {
    // 初始化
    info() {
      this.infoThree();
      this.infoBall();
      this.infoRender();
      this.renderer.domElement.addEventListener("click", this.infoMouse);
    },

    // 基本配置
    infoThree() {
      // 场景
      scene = new THREE.Scene();
      // 渲染
      this.renderer = new THREE.WebGLRenderer({
        antialias: true //抗锯齿
      });
      this.mapDom = this.$refs.mapId;
      this.renderer.setSize(this.mapDom.clientWidth, this.mapDom.clientHeight);
      this.renderer.setClearColor(0x000, 0);
      // 画布添加到页面中
      this.mapDom.appendChild(this.renderer.domElement);
      // 相机
      camera = new THREE.PerspectiveCamera(
        fov, // 视野角度
        this.mapDom.clientWidth / this.mapDom.clientHeight, // 长宽比
        1, //近截面
        1000 //远截面
      );
      camera.position.set(0, 0, 200); // 设置相机位置
      camera.lookAt(0, 0, 0);
      // 鼠标
      this.infoOrbitControls();

      // 背景深蓝色
      scene.background = new THREE.Color(0x030311);
    },

    // 重新渲染
    infoRender() {
      if (!this.renderer) {
        return;
      } // 防止在销毁后继续渲染

      this.renderer.clear();

      // 地球入场动画
      if (this.animationType) {
        this.ballAnimation();
      }
      // 地球旋转
      if (this.rotationY) {
        this.ballRotationY();
      }
      // 标记点动画
      if (this.meshAnimateType) {
        this.meshAnimate();
      }

      this.renderer.render(scene, camera);

      // 继续动画循环
      this.animationFrameId = requestAnimationFrame(this.infoRender);
      TWEEN.update();
    },


    // 鼠标
    infoOrbitControls() {
      // 创建控制器
      controls = new OrbitControls(camera, this.renderer.domElement);
      controls.enableDamping = true;
      controls.enableZoom = true;
      controls.autoRotate = false;
      controls.autoRotateSpeed = 2;
      controls.enablePan = true;
    },

    // 地球
    infoBall() {
      // 纹理贴图
      let textureLoader = new THREE.TextureLoader();

      textureLoader.load(map_img, function (texture) {
        // 创建球
        let geometry = new THREE.SphereGeometry(radius, 100, 100);

        let material = new THREE.MeshBasicMaterial({
          map: texture //设置颜色贴图属性值
        });
        //网格模型对象Mesh

        mesh = new THREE.Mesh(geometry, material);
        // 唯一标识
        mesh.name = "ballMain";
        // 添加到场景中
        scene.add(mesh);
      });
    },

    // 地球入场动画
    ballAnimation() {
      fov -= 0.6;
      if (fov <= 45) {
        this.animationType = false;
        camera.position.set(0, 0, 200);
        camera.lookAt(0, 0, 0);
        this.infoOrbitControls();
      } else {
        camera = new THREE.PerspectiveCamera(
          fov,
          this.mapDom.clientWidth / this.mapDom.clientHeight,
          1,
          1000
        );
        camera.position.set(0, 0, 200);
        camera.lookAt(0, 0, 0);
      }
    },

    // 地球自动旋转
    ballRotationY() {
      scene.rotation.y += 0.001;
    },

    // 添加纹理标记点
    infoMark(item) {
      // console.log(group);
      let cityGeometry = new THREE.PlaneBufferGeometry(1, 1); //默认在XOY平面上

      let textureLoader = new THREE.TextureLoader();

      let texture = textureLoader.load(map_wl);

      let cityWaveMaterial = new THREE.MeshBasicMaterial({
        // color: item.color,
        map: texture,
        transparent: true,
        opacity: 0,
        side: THREE.DoubleSide
      });

      let mesh = new THREE.Mesh(cityGeometry, cityWaveMaterial);
      const coord = this.lon2xyz(radius * 1.01, item.lon, item.lat);

      mesh.scale.set(2, 2, 2);
      // 唯一标识
      mesh.name = item.name;
      mesh.privateType = "mark";
      mesh.position.set(coord.x, coord.y, coord.z);
      const coordVec3 = new THREE.Vector3(
        coord.x,
        coord.y,
        coord.z
      ).normalize();
      const meshNormal = new THREE.Vector3(0, 0, 1);

      mesh.quaternion.setFromUnitVectors(meshNormal, coordVec3);
      if (scene.getObjectByName(item.name) === undefined) {
        group.add(mesh);
        //网格模型添加到场景中
        scene.add(group);
        this.meshAnimateType = true;
      }
    },

    // 标记点动画
    meshAnimate() {
      for (let i = 0; i < group.children.length; i++) {
        if (group.children[i].privateType === "mark") {
          // 添加初始随机数，防止动画同步
          group.children[i].material.opacity += Math.random() * 0.03;
          group.children[i].scale.set(
            group.children[i].material.opacity + 7,
            group.children[i].material.opacity + 7,
            group.children[i].material.opacity + 7
          );
          if (group.children[i].scale.x >= 9) {
            group.children[i].material.opacity = 0;
          }
        }
      }
    },

    // 移动相机
    cameraPos(objList) {
      this.frameDivClose();
      let layerObj = scene.getObjectByName(objList.name);
      // console.log(layerObj, "layerObj");

      if (layerObj) {
        scene.rotation.y = 0;
        this.rotationY = false;
        new TWEEN.Tween({
          x: this.lonlat.x,
          y: this.lonlat.y,
          z: this.lonlat.z
        })
          .to(
            {
              x: layerObj.position.x * 2.8,
              y: layerObj.position.y * 2.8,
              z: layerObj.position.z * 2.8
            },
            1500
          )
          .onUpdate(function () {
            camera.position.x = this.x;
            camera.position.y = this.y;
            camera.position.z = this.z;
            camera.lookAt(0, 0, 0);
          })
          .onComplete(() => {
            this.retrievalLayer(objList.name);
          })
          .easing(TWEEN.Easing.Sinusoidal.InOut)
          .start();
        this.lonlat = camera.position;
        // 弹窗面板赋值
        this.countryName = objList.name;
      } else {
        console.log(
          "图层数据已被全部删除，请重新刷新界面，或者重新调用数据初始化方法: this.infoMap ()"
        );
        // alert(
        //   "图层数据已被全部删除，请重新刷新界面，或者重新调用数据初始化方法: this.infoMap ()"
        // );
      }
    },

    // 检索指定的图层
    retrievalLayer(name) {
      let layerObj = scene.getObjectByName(name);

      this.infoDiv(
        layerObj.position.x,
        layerObj.position.y,
        layerObj.position.z
      );
    },

    // 鼠标事件（点击标记的点的事件）
    infoMouse(event) {
      event.preventDefault();
      const raycaster = new THREE.Raycaster();
      const mouse = new THREE.Vector2();
      // 通过鼠标点击位置,计算出 raycaster 所需点的位置,以屏幕为中心点,范围 -1 到 1

      let getBoundingClientRect = this.mapDom.getBoundingClientRect();

      mouse.x
        = ((event.clientX - getBoundingClientRect.left)
          / this.mapDom.offsetWidth)
          * 2
        - 1;
      mouse.y
        = -(
          (event.clientY - getBoundingClientRect.top)
          / this.mapDom.offsetHeight
        )
          * 2
        + 1;
      //通过鼠标点击的位置(二维坐标)和当前相机的矩阵计算出射线位置
      raycaster.setFromCamera(mouse, camera);
      // 获取与射线相交的对象数组，其中的元素按照距离排序，越近的越靠前
      let intersects = raycaster.intersectObjects(scene.children);
      // 点击对象的处理

      for (let i = 0; i < intersects.length; i++) {
        if (intersects[i].object.name !== "ballMain") {
          const elements = document.getElementsByClassName("home-three-map");

          for (let element of elements) {
            element.style.opacity = "0.91";
            element.style.zIndex = "11";
          }

          const navItemBtns = document.getElementsByClassName("nav-item");

          for (let navItemBtn of navItemBtns) {
            navItemBtn.style.display = "none";
          }

          const navItemLastBtns = document.getElementsByClassName("nav-item-last");

          for (let navItemLastBtn of navItemLastBtns) {
            navItemLastBtn.style.display = "none";
          }

          const navItemThreeBtns = document.getElementsByClassName("nav-item-three");

          for (let navItemThreeBtn of navItemThreeBtns) {
            navItemThreeBtn.style.display = "block";
          }

          const navItemLastThreeBtns = document.getElementsByClassName("nav-item-last-three");

          for (let navItemLastThreeBtn of navItemLastThreeBtns) {
            navItemLastThreeBtn.style.display = "block";
          }

          const elementsBtns = document.getElementsByClassName("buttonListChangeTwoToThree");

          for (let elementsBtn of elementsBtns) {
            elementsBtn.style.zIndex = "11";
            elementsBtn.style.left = "15%";
          }

          const elementsBackBtns = document.getElementsByClassName("nav-item-back");

          for (let elementsBackBtn of elementsBackBtns) {
            elementsBackBtn.style.display = "block";
          }
          // 弹窗面板赋值
          this.countryName = intersects[i].object.name;
          let objList = {
            name: intersects[i].object.name
          };

          this.cameraPos(objList);
          // this.getCurData(objList.name)
          this.$emit("handleName", objList.name);
          return false;
        }

      }
    },

    // 点击返回按钮清除所有样式
    clearStyle() {
      const elements = document.getElementsByClassName("home-three-map");

      for (let element of elements) {
        element.style.opacity = "1";
        element.style.zIndex = "0";
      }

      const elementsBtns = document.getElementsByClassName("buttonListChangeTwoToThree");

      for (let elementsBtn of elementsBtns) {
        elementsBtn.style.zIndex = "8";
        elementsBtn.style.left = "540px";
      }

      const elementsBackBtns = document.getElementsByClassName("nav-item-back");

      for (let elementsBackBtn of elementsBackBtns) {
        elementsBackBtn.style.display = "none";
      }

      const navItemBtns = document.getElementsByClassName("nav-item");

      for (let navItemBtn of navItemBtns) {
        navItemBtn.style.display = "block";
      }

      const navItemLastBtns = document.getElementsByClassName("nav-item-last");

      for (let navItemLastBtn of navItemLastBtns) {
        navItemLastBtn.style.display = "block";
      }

      const navItemThreeBtns = document.getElementsByClassName("nav-item-three");

      for (let navItemThreeBtn of navItemThreeBtns) {
        navItemThreeBtn.style.display = "none";
      }

      const navItemLastThreeBtns = document.getElementsByClassName("nav-item-last-three");

      for (let navItemLastThreeBtn of navItemLastThreeBtns) {
        navItemLastThreeBtn.style.display = "none";
      }

      const buttonListBoxBtns = document.getElementsByClassName("buttonList-box");

      for (let buttonListBoxBtn of buttonListBoxBtns) {
        buttonListBoxBtn.style.zIndex = "8";
        buttonListBoxBtn.style.left = "1212px";
        buttonListBoxBtn.style.bottom = "180px";
      }

      // 开启自动旋转
      this.rotationY = true;
      this.frameDivClose();
    },

    // getCurData(name) {
    //   console.log(name, "我是name")
    //   this.objList.forEach((item) => {
    //     if (item.name == name) {
    //       this.curData = item
    //     }
    //   })
    // },
    // 标签
    infoDiv(pointx, pointy, pointz) {
      console.log(pointx, pointy, pointz);
      // 坐标转换
      let world_vector = new THREE.Vector3(pointx, pointy, pointz);

      let vector = world_vector.project(camera);

      let halfWidth = this.mapDom.offsetWidth / 2,
        halfHeight = this.mapDom.offsetHeight / 2;

      let x = Math.round(vector.x * halfWidth + halfWidth);

      let y = Math.round(-vector.y * halfHeight + halfHeight);
      //创建div容器

      let moonDiv = document.getElementById("layerMain");

      moonDiv.style.display = "block";
      moonDiv.style.left = x - (-2) + "px";
      moonDiv.style.top = y - 185 + "px";
    },

    // 关闭标签
    frameDivClose() {
      let divHtml = document.getElementById("layerMain");

      divHtml.style.display = "none";
      this.$emit("closeDialog");
    },

    // 添加光柱
    infoColumn(item) {
      const material = new THREE.MeshBasicMaterial({
        // color: item.color,
        transparent: true,
        opacity: 0.9,
        side: THREE.DoubleSide
      });
      const coord = this.lon2xyz(radius * 1.01, item.lon, item.lat);
      const coordVec3 = new THREE.Vector3(
        coord.x,
        coord.y,
        coord.z
      ).normalize();
      const geometry = new THREE.CylinderGeometry(0.2, 2.8, 30);
      const mesh = new THREE.Mesh(geometry, material);

      mesh.name = item.name;
      mesh.privateType = "column";
      mesh.position.set(coord.x, coord.y, coord.z);
      mesh.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), coordVec3);
      group.add(mesh);
      scene.add(group);
    },
    // ----------------------------

    initLine2() {
      //定接收信号的点
      var arr = posArr.map((pos) => {
        var geometry = new THREE.PlaneGeometry(0.1, 0.1);
        var material = new THREE.PointsMaterial({
          color: "tomato"
        });
        var points = new THREE.Points(geometry, material);

        points.position.set(pos.x, pos.y, pos.z);
        groupDots.add(points);
      });
      //飞线（添加贝塞尔曲线）
      var animateDots = [];

      groupDots.children.forEach((elem) => {
        // debugger
        // console.log(groupDots.children[0].position,elem.position)
        var line = addLines(groupDots.children[0].position, elem.position);
        // var line = addLines(posArr[0], posArr[1]);

        groupLines.add(line.lineMesh);
        // animateDots.push(line.curve.getPoints(100));
        scene.add(groupLines);
      });
      console.log(groupDots.children.position, 666);
    },
    initLine() {},
    // -----------------
    // 删除所有标记点
    delAll() {
      this.frameDivClose();
      group.traverse((item) => {
        if (item.type === "Mesh") {
          item.geometry.dispose();
          item.material.dispose();
        }
      });
      scene.remove(group);
      // 删除group中的children
      if (group.children && group.children.length > 0) {
        let i = 0;

        for (i; i < group.children.length; i++) {
          group.remove(group.children[i]);
        }
      }
    },

    // 删除指定标记点
    delMark(item) {
      this.frameDivClose();
      let layerObj = scene.getObjectByName(item.name);

      group.remove(layerObj);
    },

    // 经纬度转坐标
    lon2xyz(R, longitude, latitude) {
      const lon = (Number(longitude) + 90) * (Math.PI / 180);
      const lat = Number(latitude) * (Math.PI / 180);
      const x = R * Math.cos(lat) * Math.sin(lon);
      const y = R * Math.sin(lat);
      const z = R * Math.cos(lon) * Math.cos(lat);

      return { x, y, z };
    }
  }
};
</script>

<style lang="scss">
#layerMain {
  position: absolute;
  width: 496px;
  height: 208px;
  border-radius: 17px;
  // line-height: 160px;
  text-align: left;
  color: white;
  display: none;
  //background-color: rgba(34, 34, 35, 0.6);
  background-image: url(./img/bg_tc.png);
  background-size: 100% 100%;
  //border: 1px solid #fff;
  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 99;
    //background: #000;
    opacity: 0.1;
    // border-radius: 10px;
  }
  .layerContent {
    margin: 20px;
    //max-height: 140px;
    display: flex;
    justify-content: space-evenly;
  }
  .shape {
    //background-color: #00F6FF;
    position: absolute;
    margin: auto;
    left: -50px;
    right: 0;
    top: -20px;
    width: 110px;
    bottom: -40px;
    overflow: hidden;
  }
  .plane {
    position: absolute;
    width: 50px;
    top: 158px;
    left: 80px;
  }
  .left {
    float: left;
    margin-left: 120px;
  }
  .right {
    float: right;
  }
  .clear {
    clear: both;
  }
  .layer-left {
    //width: 60%;
  }
  .layer-right {
    //width: 40%;
  }
  .layer-left-top {
    display: flex;
    align-items: center;
  }
  .layer-top-cont {
    font-family: YouSheBiaoTiHei;
    display: inline-block;
    margin-right: 10px;
    font-size: 30px;
  }
  .layer-left-top img {
    width: 30px;
    height: 20px;
    vertical-align: middle;
  }
  .layer-bot-num {
    font-family: YouSheBiaoTiHei;
    font-size: 30px;
  }
  .layer-left-bot {
    margin-top: 50px;
    .layer-bot-num {
      margin-right: 10px;
      font-weight: 700;
      font-size: 40px;
    }
  }
  .layer-right-li {
    text-align: center;
    margin: 0;
    margin-bottom: 10px;
    opacity: 1;
    p {
      text-align: right;
      font-size: 14px;
      margin: 0;
      color: white;
      font-weight: bold;
    }
  }
}
</style>
